<div class="content-container">
  <mat-toolbar class="sticky-toolbar">
    <h2>
      <span class="opacity-75">
        <a routerLink="/home" id="downloads-breadcrumb-home">Home</a> /
      </span>
      {{ pageTitle }}
    </h2>
    <span class="spacer"></span>
    <button mat-mini-fab [matMenuTriggerFor]="downloadsActions" id="downloads-actions-button" matTooltip="More options">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #downloadsActions="matMenu">
      <button mat-menu-item id="downloads-refresh-button" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </mat-menu>
  </mat-toolbar>

  <div class="sub-content-container">
    <div class="container-fluid pd-20">
      <mat-card class="portal-page-card">
        <mat-card-header class="downloads-header" [class.vault-active]="active === 2">
          <div mat-card-avatar class="downloads-avatar">
            <mat-icon [class.vault-open]="active === 2" id="downloads-mode-icon">{{ active === 2 ? 'shield_locked' : 'download'
              }}</mat-icon>
          </div>
          <mat-card-title>{{ active === 2 ? 'Vault' : 'Latest Downloads' }}</mat-card-title>
          <mat-card-subtitle>
            {{ active === 2 ? 'Access older packages, installers, and documentation for the selected contract.' : '' }}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="page-loading-card" *ngIf="loading">
            <mat-spinner diameter="56"></mat-spinner>
          </div>

          <ng-container *ngIf="!loading">
            <ng-container *ngIf="active === 1">
              <mat-accordion class="downloads-accordion" multi *ngIf="contract.active">
                <ng-container *ngFor="let item of products">
                  <mat-expansion-panel [id]="'downloads-supported-' + item.config.name.toLowerCase()"
                    *ngIf="!isCloneManager(item.config.name)">
                    <mat-expansion-panel-header><mat-panel-title>{{ item.config.displayName
                        }}</mat-panel-title></mat-expansion-panel-header>
                    <app-download-tabs [archived]="item.data" [product]="item.config.name" [showISOs]="item.config.showISOs"
                      [showAPI]="item.config.showAPI" [showUpgrades]="item.config.showUpgrades" [showBundles]="item.config.showBundles">
                    </app-download-tabs>
                  </mat-expansion-panel>
                </ng-container>
                <mat-expansion-panel id="downloads-supported-clonemanager" *ngIf="hasCloneManager">
                  <mat-expansion-panel-header><mat-panel-title>CloneManager</mat-panel-title></mat-expansion-panel-header>
                  <div class="notice">
                    <div class="notice-body">CloneManager is no longer available for download. Both CloneManager Online and CloneManager
                      Offline are
                      included as part of the replicate feature of the Cristie Appliance.</div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="notice notice-error" *ngIf="!contract.active">
                <div class="notice-body">
                  Your contract has expired, so latest downloads are unavailable. To renew your contract, contact
                  <a href="mailto:sales&#64;cristie.com">sales&#64;cristie.com</a>.
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="active === 2">
              <mat-accordion class="downloads-accordion downloads-vault" multi>
                <mat-expansion-panel id="downloads-archived-empty" *ngIf="showVaultExpiryNotice" [expanded]="true">
                  <mat-expansion-panel-header>
                    <mat-panel-title>No Archived Downloads Available</mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="notice">
                    <div class="notice-body">
                      Your maintenance expired on {{ contract.endDate | date: "dd MMMM yyyy" }}. Only downloads released before then are
                      available.
                    </div>
                  </div>
                </mat-expansion-panel>
                <ng-container *ngFor="let item of products">
                  <mat-expansion-panel [id]="'downloads-archived-' + item.config.name.toLowerCase()"
                    *ngIf="!isCloneManager(item.config.name)">
                    <mat-expansion-panel-header><mat-panel-title>{{ item.config.displayName
                        }}</mat-panel-title></mat-expansion-panel-header>
                    <app-download-tabs [archived]="item.data" [product]="item.config.name" [showISOs]="item.config.showISOs"
                      [showAPI]="item.config.showAPI" [showUpgrades]="item.config.showUpgrades" [showBundles]="item.config.showBundles">
                    </app-download-tabs>
                  </mat-expansion-panel>
                </ng-container>
                <mat-expansion-panel id="downloads-archived-clonemanager" *ngIf="hasCloneManager">
                  <mat-expansion-panel-header><mat-panel-title>CloneManager</mat-panel-title></mat-expansion-panel-header>
                  <div class="notice">
                    <div class="notice-body">CloneManager is no longer available for download. Both CloneManager Online and CloneManager
                      Offline are
                      included as part of the replicate feature of the Cristie Appliance.</div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </ng-container>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>